import { action, observable } from "mobx";
import { ModelBase } from "@shoothill/core";
import { PackageCategoriesResult } from "./PackageCategoriesResult";

export class ROFilterParamsModel extends ModelBase<ROFilterParamsModel, ROFilterParamsModelDTO> {
    @observable
    public includeDeleted: boolean = false;

    @observable
    public isRejected: boolean = false;

    @observable
    public categories: number[] | null = [];

    @observable
    public subCategories: number[] | null = [];

    @observable
    public statuses: string[] | null = []; //[100, 200, 300]

    @observable
    public orderTypes: string[] | null = []; //[100, 200]

    @observable
    public cells: number[] | null = []; //[1, 2, 3]

    @observable
    public raisedByIds: string[] | null = [];

    @observable
    public projects: string[] | null = [];

    @observable
    public searchText: string = "";

    fromDto(model: ROFilterParamsModelDTO): void {
        this.categories = model.categories;
        this.subCategories = model.subCategories;
        this.searchText = model.searchText;
    }

    toDto(): ROFilterParamsModelDTO {
        let dto: ROFilterParamsModelDTO = {
            includeDeleted: this.includeDeleted,
            isRejected: true,
            categories: this.categories,
            subCategories: this.subCategories,
            statuses: this.statuses,
            orderTypes: this.orderTypes,
            cells: this.cells,
            searchText: this.searchText,
            raisedByIds: this.raisedByIds,
            projects: this.projects,
        };
        return dto;
    }

    @action
    public setCategoriesAndSubFilters = (result: PackageCategoriesResult) => {
        if (result !== null && result.categories !== null && result.categories.length > 0) {
            this.categories = result.categories.map((a) => a.id);
        }

        if (result !== null && result.subCategories !== null && result.subCategories.length > 0) {
            this.subCategories = result.subCategories.map((a) => a.id);
        }
    };

    @action
    public reset = () => {
        this.categories = [];
        this.subCategories = [];
        this.statuses = [];
        this.orderTypes = [];
        this.cells = [];
        this.searchText = "";
        this.raisedByIds = [];
        this.projects = [];
    };
}

export interface ROFilterParamsModelDTO {
    includeDeleted: boolean;
    isRejected: boolean;
    categories: number[] | null;
    subCategories: number[] | null;
    statuses: string[] | null;
    orderTypes: string[] | null;
    cells: number[] | null;
    searchText: string;
    raisedByIds: string[] | null;
    projects: string[] | null;
}
